import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { BorrowerStatusReason } from 'app/services/borrower-status/borrower-status-reason.model';
import { BorrowerStatusReasonService } from 'app/services/borrower-status/borrower-status-reason.service';
import { tap } from 'rxjs/operators';
import { GetBorrowerStatusReasons } from './borrower-status-reason.actions';

export class BorrowerStatusReasonStateModel {
  loaded: boolean;
  reasons: BorrowerStatusReason[];
}

@State<BorrowerStatusReasonStateModel>({
  name: 'borrowerStatusReason',
	defaults: {
    loaded: false,
    reasons: []
	}
})

@Injectable()

export class BorrowerStatusReasonState {

  @Selector()
	static reasons(state: BorrowerStatusReasonStateModel) {
    return state.reasons;
  }

  constructor(
    private borrowerStatusReasonService: BorrowerStatusReasonService
  ) {}

  @Action(GetBorrowerStatusReasons)
  getBorrowerStatusReasons({ getState, patchState }: StateContext<BorrowerStatusReasonStateModel>, _: GetBorrowerStatusReasons) {
    // prevent unnecessary api calls
    if (getState().loaded) {
      return;
    }
    patchState({ loaded: true });

    // fetch reasons
    return this.borrowerStatusReasonService.get().pipe(
      tap(reasons => {
        patchState({ reasons });
      })
    );
  }
}
